module.exports = __webpack_public_path__ + "img/IT0000574292849.5522a3cc.png";